import React from "react";
import styles from "./index.module.scss";

interface ReviewDrawerHeaderProps {
    studentName?: string;
    studentNo?: string;
    paperName?: string;
    endTime?: string;
}

export default function ReviewDrawerHeader({
    studentName,
    studentNo,
    paperName,
    endTime
}: ReviewDrawerHeaderProps) {
    return (
        <div className={styles.root}>
            <div className={styles.name}>
                {studentName} {studentNo}学号
            </div>

            {paperName && endTime && (
                <div className={styles.info}>
                    {paperName} | 提交时间 {endTime}
                </div>
            )}
        </div>
    );
}
